import { Check } from 'lucide-react';

export function QuestionStep({ question, value, onSelect }) {
    const { id, type, label, help, options, micro } = question;
    const isSelected = (opt) =>
        type === 'multi' ? (value || []).includes(opt) : value === opt;

    return (
        <div data-testid={`snapshot-question-${id}`}>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-cyan-400">
                Question
            </p>
            <h3 className="mt-3 font-display font-semibold text-[1.7rem] md:text-[2.1rem] leading-[1.1] tracking-[-0.03em] text-white">
                {label}
            </h3>
            {micro && (
                <p
                    data-testid={`snapshot-micro-${id}`}
                    className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-400/80"
                >
                    {micro}
                </p>
            )}
            {help && (
                <p className="mt-3 text-[14px] text-slate-400">
                    {help}
                </p>
            )}

            <ol className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-2">
                {options.map((opt) => {
                    const on = isSelected(opt);
                    return (
                        <li key={opt} className="list-none">
                            <button
                                type="button"
                                data-testid={`snapshot-option-${id}-${opt.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}
                                onClick={() => onSelect(id, type, opt)}
                                className="w-full text-left flex items-start gap-3 px-4 py-3.5 rounded-xl transition-all duration-300"
                                style={{
                                    background: on ? 'rgba(6,182,212,0.10)' : 'rgba(255,255,255,0.025)',
                                    border: on ? '1px solid rgba(6,182,212,0.45)' : '1px solid rgba(255,255,255,0.08)',
                                    boxShadow: on ? '0 0 22px -4px rgba(6,182,212,0.35)' : 'none',
                                }}
                                onMouseEnter={(e) => {
                                    if (!on) {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.045)';
                                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.18)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!on) {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.025)';
                                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
                                    }
                                }}
                            >
                                <span
                                    className={`mt-0.5 grid place-items-center shrink-0 ${type === 'multi' ? 'rounded-md' : 'rounded-full'}`}
                                    style={{
                                        width: 18,
                                        height: 18,
                                        background: on ? 'linear-gradient(135deg, #06B6D4, #3B82F6)' : 'transparent',
                                        border: `1px solid ${on ? '#06B6D4' : 'rgba(255,255,255,0.20)'}`,
                                    }}
                                >
                                    {on && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
                                </span>
                                <span className={`text-[14.5px] leading-[1.45] ${on ? 'text-white' : 'text-slate-300'}`}>
                                    {opt}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ol>

            {type === 'multi' && (
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                    {(value || []).length} selected · optional
                </p>
            )}
        </div>
    );
}
